import { Helper } from '@/mixin/helper'

// Note:
// - The configuration is like tableFilterFields on other feature. You can check on other field with file name: tableFilterFields.js

export default {
  computed: {
    reportFilterFields() {
      return {
        minKmMileage: {
          key: 'minKmMileage',
          name: 'minKmMileage',
          isShow: true,
          _type: 'number',
          type: 'custom-input',
          label: this.$t('report.fields.minKmMileage'),
          placeholder: this.$t('report.placeholder.minKmMileage'),
          suffix: 'Km',
          validation: 'optional|number',
          errorBehavior: 'live',
          handleKeypress: (event) => Helper.methods.isDecimal(event),
        },
        minMinuteTripDuration: {
          key: 'minMinuteTripDuration',
          name: 'minMinuteTripDuration',
          isShow: true,
          _type: 'number',
          type: 'custom-input',
          label: this.$t('report.fields.minMinuteTripDuration'),
          placeholder: this.$t('report.placeholder.minMinuteTripDuration'),
          suffix: this.$t('global.time.minutes'),
          validation: 'optional|number',
          errorBehavior: 'live',
          handleKeypress: (event) => Helper.methods.isNumeric(event),
        },
      }
    },
  },
}
